module.exports = __webpack_public_path__ + "img/zeitgard_hautreinigung.22d1e46a.jpg";